/**
 * H5 后管侧栏菜单（非教培一级项）
 * key 与 sys_user.h5_admin_menus / H5AdminUserVo.h5AdminMenus 对齐
 */

export const H5_ADMIN_MENU_KEYS = {
  HOME: 'home',
  REDBOOK: 'redbook',
  SIGNS_USERS: 'signs_users',
  SIGNS_ACTIVITIES: 'signs_activities',
  SIGNS_JOIN_RECORDS: 'signs_join_records',
  SIGNS_CHECKIN_LOGS: 'signs_checkin_logs',
  SEAL_CATEGORY: 'seal_category',
  SEAL_STOCK: 'seal_stock',
  SEAL_HANDLE: 'seal_handle',
  SEAL_SUPPLIER: 'seal_supplier',
  SEAL_PRODUCE: 'seal_produce',
  SCHOOLS_PLATFORM_ORGS: 'schools_platform_orgs',
  SCHOOLS_DASHBOARD: 'schools_dashboard',
  SCHOOLS_SUBJECT: 'schools_subject',
  SCHOOLS_COURSE: 'schools_course',
  SCHOOLS_CLASS: 'schools_class',
  SCHOOLS_SCHEDULE: 'schools_schedule',
  SCHOOLS_STUDENT: 'schools_student',
  SCHOOLS_ENROLL: 'schools_enroll',
  SCHOOLS_ATTENDANCE: 'schools_attendance',
  SCHOOLS_LEAVE: 'schools_leave',
  SCHOOLS_TEACHER: 'schools_teacher',
  SCHOOLS_ROOM: 'schools_room',
  SCHOOLS_NOTICE: 'schools_notice',
  SCHOOLS_SETTING: 'schools_setting'
}

export const h5AdminMenus = [
  { key: H5_ADMIN_MENU_KEYS.HOME, index: '/admin/home', title: '首页', icon: 'el-icon-s-home' },
  { key: H5_ADMIN_MENU_KEYS.REDBOOK, index: '/admin/redbook', title: '小红书活动', icon: 'el-icon-document' },
  { key: H5_ADMIN_MENU_KEYS.SIGNS_USERS, index: '/admin/signs/users', title: '用户管理', icon: 'el-icon-user' },
  {
    key: H5_ADMIN_MENU_KEYS.SIGNS_ACTIVITIES,
    index: '/admin/signs/activities',
    title: '打卡活动管理',
    icon: 'el-icon-s-claim'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SIGNS_JOIN_RECORDS,
    index: '/admin/signs/join-records',
    title: '打卡参与信息',
    icon: 'el-icon-s-order'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SIGNS_CHECKIN_LOGS,
    index: '/admin/signs/checkin-logs',
    title: '打卡明细信息',
    icon: 'el-icon-tickets'
  }
]

/** 印章管理分组（一级：印章管理；二级：规格 / 手柄 / 供应商 / 库存） */
export const h5AdminSealMenus = [
  {
    key: H5_ADMIN_MENU_KEYS.SEAL_CATEGORY,
    index: '/admin/seal/category',
    title: '印章规格',
    icon: 'el-icon-collection-tag'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SEAL_HANDLE,
    index: '/admin/seal/handle',
    title: '手柄维护',
    icon: 'el-icon-s-tools'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SEAL_SUPPLIER,
    index: '/admin/seal/supplier',
    title: '供应商',
    icon: 'el-icon-office-building'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SEAL_PRODUCE,
    index: '/admin/seal/produce',
    title: '生产需求',
    icon: 'el-icon-s-order'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SEAL_STOCK,
    index: '/admin/seal/stock',
    title: '印章库存',
    icon: 'el-icon-box'
  }
]

/** 兼容旧缓存：无 menus 时默认首页+小红书 */
const DEFAULT_MENUS = [H5_ADMIN_MENU_KEYS.HOME, H5_ADMIN_MENU_KEYS.REDBOOK]

/** 父级 key → 叶子 key（控台树父节点 id=seal） */
const SEAL_PARENT_KEYS = ['seal', 'seal_mgmt', 'seal_manage']

function expandMenuKeys(keys) {
  const out = []
  const seen = new Set()
  ;(keys || []).forEach((raw) => {
    const key = String(raw || '').trim()
    if (!key) return
    const add = (k) => {
      if (!k || seen.has(k)) return
      seen.add(k)
      out.push(k)
    }
    if (SEAL_PARENT_KEYS.indexOf(key) >= 0) {
      add(H5_ADMIN_MENU_KEYS.SEAL_CATEGORY)
      add(H5_ADMIN_MENU_KEYS.SEAL_HANDLE)
      add(H5_ADMIN_MENU_KEYS.SEAL_SUPPLIER)
      add(H5_ADMIN_MENU_KEYS.SEAL_PRODUCE)
      add(H5_ADMIN_MENU_KEYS.SEAL_STOCK)
      return
    }
    add(key)
  })
  return out
}

export function resolveH5AdminMenuKeys(userInfo) {
  if (!userInfo) {
    return expandMenuKeys(DEFAULT_MENUS.slice())
  }
  // 兼容 camelCase / snake_case，以及登录缓存里偶发的字符串
  const raw = userInfo.h5AdminMenus != null
    ? userInfo.h5AdminMenus
    : userInfo.h5_admin_menus
  let keys
  if (Array.isArray(raw) && raw.length) {
    keys = raw.map(item => String(item).trim()).filter(Boolean)
  } else if (typeof raw === 'string' && raw.trim()) {
    keys = raw.split(/[,，;\s]+/).map(item => item.trim()).filter(Boolean)
  } else {
    keys = DEFAULT_MENUS.slice()
  }
  return expandMenuKeys(keys)
}

export function filterH5AdminMenus(userInfo) {
  const allowed = new Set(resolveH5AdminMenuKeys(userInfo))
  return h5AdminMenus.filter(item => allowed.has(item.key))
}

export function filterH5AdminSealMenus(userInfo) {
  const allowed = new Set(resolveH5AdminMenuKeys(userInfo))
  return h5AdminSealMenus.filter(item => allowed.has(item.key))
}

export function resolveH5AdminActiveMenu(path) {
  if (!path) return path
  if (path.indexOf('/admin/signs/') === 0) return path
  if (path.indexOf('/admin/seal/') === 0) return path
  return path
}

export function hasH5AdminMenu(userInfo, menuKey) {
  if (!menuKey) return true
  return resolveH5AdminMenuKeys(userInfo).indexOf(menuKey) >= 0
}

/** 是否拥有任一印章库存菜单权限 */
export function hasAnySealH5AdminMenu(userInfo) {
  return resolveH5AdminMenuKeys(userInfo).some(key => String(key).indexOf('seal_') === 0)
}

/** 是否拥有任一教培二级菜单权限 */
export function hasAnySchoolsH5AdminMenu(userInfo) {
  return resolveH5AdminMenuKeys(userInfo).some(key => String(key).indexOf('schools_') === 0)
}
